/** Quiet, layered arena scenery behind the party's fighters and controls. */
export function partyBackdrop(presetId: string): HTMLElement {
  const backdrop = document.createElement('div');
  backdrop.className = 'party-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  const scene = presetId === 'pirate' ? pirateScene()
    : presetId === 'neon' ? neonScene()
      : presetId === 'office-brawl' ? officeScene()
        : forestScene();
  backdrop.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 1000" preserveAspectRatio="xMidYMid slice" focusable="false">${scene}</svg>`;
  return backdrop;
}

function fir(x: number, y: number, scale: number, fill: string): string {
  return `<path fill="${fill}" transform="translate(${x} ${y}) scale(${scale})" d="M-7 0v-46h-64l40-49h-27l42-52h-24L0-210l40 63H16l42 52H31l40 49H7V0Z"/>`;
}

function forestScene(): string {
  return `
    <path fill="#0b2026" d="M0 0h1600v1000H0z"/>
    <path fill="#102c32" d="M475 0h1125v652H530l87-159-44-159 78-126Z"/>
    <path fill="#17383e" d="M621 430 771 285l72 86 180-177 139 160 85-94 159 181 90-111 104 84v289H621Z"/>
    <path fill="#1d4347" d="m877 431 146-237 139 160-112-70-40 59-46-11Z"/>
    <path fill="#20484b" d="m1253 386 86-126 159 181-120-76-24 27-45-31Z"/>
    <circle cx="1237" cy="177" r="55" fill="#92b7af"/>
    <path fill="#aac8bd" d="M1231 125a55 55 0 0 1 36 100 59 59 0 0 0-36-100Z"/>
    <path fill="#25464a" d="M1001 206h109l17 7h118l15 8h-248Zm324 81h121l19 8h135v10h-248Z"/>
    <path fill="#173539" d="m544 503 113-42 124 27 119-48 112 25 116-10 137 46 144-25 191 28v224H544Z"/>
    <path fill="#24494a" d="m653 469 41-30 43 7 13 12-37 8Z"/>
    <path fill="#112e32" d="m1051 485 64-16 69 7 33 24-87 8-55-8Zm-282 62 58-18 74 11 44 23-96 8Z"/>
    ${fir(792, 544, .47, '#173539')}
    ${fir(879, 514, .35, '#173539')}
    ${fir(1448, 566, .86, '#102b30')}
    ${fir(1574, 596, 1.2, '#0d252b')}
    ${fir(1367, 560, .51, '#102b30')}
    <path fill="#315b58" d="m578 661 149-19 164 7 125-14 208 12 164-5 212 30v34H569Z"/>
    <path fill="#1b373b" d="m565 675 169-14 158 10 126-13 205 11 165-4 212 26v162H568Z"/>
    <path fill="#152d33" d="m565 693 135 25 47 96 59 22 72 99H538Zm331-15 44 80 127 49 25 81 115-46 73 47 158-65 162-18v194H616Z"/>
    <path fill="#244347" d="m724 674 55 37 85-30 27-10Zm349-11 61 36 100-28Zm317 4 85 73 87-51Z"/>
    <path fill="#0c2229" d="m0 702 324-22 230 50 113 94 251 44 251-23 202 39 229-16v132H0Z"/>
    <path fill="#3c635c" d="m695 649-5-18 11 13 8-23 2 26Zm668-4 5-20 6 12 11-24-5 32Z"/>
    <path d="m1126 303 10-5 9 4m22-18 8-4 8 4" fill="none" stroke="#547575" stroke-width="3" stroke-linecap="round"/>
    <path fill="#678d7b" d="m1354 593 3-5 3 5-3 5Zm-429 24 2-4 2 4-2 4Z"/>`;
}

function pirateScene(): string {
  return `
    <path fill="#111f28" d="M0 0h1600v1000H0z"/>
    <path fill="#182e38" d="M537 0h1063v632H573l69-183-40-138 55-146Z"/>
    <circle cx="1239" cy="177" r="56" fill="#cfb687"/>
    <path fill="#2b4249" d="M1110 215h138l22 8h130l19 9h-282Zm276 98h125l17 8h72v9h-186Z"/>
    <path fill="#233d45" d="m608 506 92-19 75-88 24-10 44 71 74 40 47 39h636v175H608Z"/>
    <path fill="#29454d" d="M604 533h996v188H604Z"/>
    <path fill="#36565c" d="m956 581 173-2 47 5h-220Zm261 45h168l32 5h-200Zm-379 9h59l17 4h-87Zm636-88h126v4h-151Z"/>
    <path fill="#142b35" d="m1260 503 210 1-44 47-128-7Z"/>
    <path fill="#1a3139" d="M1356 268h9v247h-9Z"/>
    <path fill="#3e5355" d="m1345 290-9 151-126-11Zm31 11 7 143 115 7-47-110Z"/>
    <path fill="#253f46" d="m1345 290-47 130-88 10Zm32 12 121 149-77-35Z"/>
    <path fill="#d1a66a" d="m1364 268 56 6-21 15-35-8Z"/>
    <path fill="#4b4e46" d="m569 664 155-19 203 10 145-16 242 13 286 28v30H563Z"/>
    <path fill="#333d3c" d="m563 681 161-17 203 11 145-17 242 13 286 28v25L563 711Z"/>
    <path fill="#202e32" d="m646 698 25 4-13 141-20-1Zm422-18 24 2 10 202-24-2Zm431 36 31 4 18 152-28 2Z"/>
    <path d="m768 666 11 31m118-25 10 28m146-36 9 36m133-34 10 41m140-29 11 32m115-17 10 29" stroke="#202e32" stroke-width="4"/>
    <path fill="#474d46" d="M1500 583h19l7 112-29-2Z"/>
    <path fill="#777660" d="M1497 578h24v13h-24Z"/>
    <path d="M1510 606q47 35 90 23" fill="none" stroke="#7b7660" stroke-width="5"/>
    <path fill="#0e2029" d="m0 717 453-5 193 104 317 58 327-35 310 47v114H0Z"/>
    <path d="m985 275 11-6 11 6m25-25 8-4 8 4" fill="none" stroke="#758886" stroke-width="3" stroke-linecap="round"/>`;
}

function neonScene(): string {
  return `
    <path fill="#091c25" d="M0 0h1600v1000H0z"/>
    <path fill="#102c35" d="M570 0h1030v700H621l-31-182 68-211-59-159Z"/>
    <circle cx="1260" cy="173" r="49" fill="#739b99"/>
    <path fill="#17414a" d="M631 587V391h72v-99h84v126h49V225h76v-49h16v49h34v362Zm339 0V396h70V312h61v57h44V241h89v346Zm291 0V342h82V200h91v77h59v192h54V303h53v330Z"/>
    <path fill="#29606a" d="M850 266h6v188h-6Zm310 18h54v5h-54Zm0 24h54v5h-54Zm204-67h48v5h-48Zm0 25h48v5h-48Zm0 25h48v5h-48ZM713 329h54v5h-54Zm0 25h54v5h-54Z"/>
    <path fill="#102d38" d="M692 638V472h114v166Zm143 0V405h72v233Zm286 0V421h70v217Zm120 0V486h98v152Zm150 0V402h111v236Zm137 0V520h72v118Z"/>
    <path fill="#398087" d="M710 501h67v5h-67Zm0 23h67v5h-67Zm427-70h5v131h-5Zm228-22h8v142h-8Z"/>
    <path fill="#547c75" d="M981 190h3v3h-3Zm165-92h3v3h-3Zm323 82h3v3h-3Z"/>
    <path fill="#36757a" d="m579 665 227-13 274-14 254 19 266 17v9l-266-15-254-18-274 13-227 11Z"/>
    <path fill="#1a3942" d="m568 678 238-13 274-14 254 18 266 17v123H568Z"/>
    <path fill="#234852" d="m665 704 166-21 247-17 232 21 168 44-277-17-127-10-244 14Z"/>
    <path d="m887 697-77 35m266-27v39m224-29 60 29m-631-11 149-4m369 5 168 6" fill="none" stroke="#3e787c" stroke-width="3"/>
    <path fill="#18313b" d="M1519 545h13v159h-13Z"/>
    <path fill="#345d64" d="M1506 537h38v12h-38Z"/>
    <path fill="#6bc4c1" d="M1509 539h32v5h-32Z"/>
    <path fill="#0a202b" d="m0 715 456-7 195 112 310 45 313-34 326 38v131H0Z"/>`;
}

function officeScene(): string {
  return `
    <path fill="#15232b" d="M0 0h1600v1000H0z"/>
    <path fill="#253b45" d="M606 0h994v690H606Z"/>
    <path fill="#304c56" d="M650 174h950v361H650Z"/>
    <path fill="#223944" d="M650 453h65V336h61v77h49V292h76v56h67v131h36V315h105v67h60V255h73v173h67V359h85v82h75V304h92v138h39v93H650Z"/>
    <path fill="#3a5860" d="M751 368h5v54h-5Zm78-51h52v5h-52Zm197 35h64v5h-64Zm152-67h43v5h-43Zm0 24h43v5h-43Zm324 22h27v5h-27Z"/>
    <path fill="#152b35" d="M650 164h950v15H650Zm0 369h950v16H650Zm89-359h14v360h-14Zm264 0h14v360h-14Zm264 0h14v360h-14Zm264 0h14v360h-14Z"/>
    <path fill="#38515a" d="M665 92h403v11H665Zm483 0h347v11h-347Z"/>
    <path fill="#86a49c" d="M682 95h369v4H682Zm483 0h313v4h-313Z"/>
    <path fill="#1c323b" d="M645 565h955v9H645Z"/>
    <path fill="#2b4650" d="M1316 618h267v18h-267Z"/>
    <path fill="#152c36" d="M1330 636h11v53h-11Zm229 0h11v64h-11Z"/>
    <path fill="#172c35" d="M1386 548h99v59h-99Z"/>
    <path fill="#45656c" d="M1393 554h84v44h-84Z"/>
    <path fill="#172c35" d="M1429 606h14v12h-14Zm-18 8h50v6h-50Z"/>
    <path fill="#0e2631" d="m1528 662-6-72h-46l-11 17v57Zm-47 5h16v26h-16Zm-19 25h57v8h-57Z"/>
    <path fill="#3a4c50" d="m589 670 385-23 313 13 313 32v155H580Z"/>
    <path fill="#2e4249" d="m589 690 385-22 313 14 313 29v137H580Z"/>
    <path d="m763 680-133 134m356-142 7 166m244-159 132 135m-822-71 1039 52" fill="none" stroke="#263b44" stroke-width="4"/>
    <path fill="#152932" d="m0 713 452-10 214 132 305 37 299-40 330 56v112H0Z"/>`;
}
